const getSummary = (id) => {
    const error = window.i18n.__(
        'Un problème est survenu lors de la récupération du résumé. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.get(`/summary-with-ai/company/${id}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const generateSummary = (id) => {
    const error = window.i18n.__(
        'Un problème est survenu lors de la génération du résumé. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.post(`/summary-with-ai/company/${id}/generate`, {}, {})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

export { getSummary, generateSummary };
